import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Sheet, SheetContent, SheetHeader, SheetTitle,
} from '../ui/sheet';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { Loader2 } from 'lucide-react';

export function ChantierFormSheet({
  open, onOpenChange, editingChantier,
  formData, setFormData, submitting, onSubmit,
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-lg overflow-y-auto" aria-describedby="chantier-form-desc">
        <SheetHeader>
          <SheetTitle>{editingChantier ? 'Modifiér le chantier' : 'Nouveau chantier'}</SheetTitle>
          <p id="chantier-form-desc" className="text-sm text-[#4B5563]">
            {editingChantier ? 'Modifiéz les informations du chantier' : 'Creez un nouveau chantier'}
          </p>
        </SheetHeader>
        <form onSubmit={onSubmit} className="space-y-4 mt-6 pb-8 overflow-y-auto max-h-[calc(100vh-160px)] max-h-[calc(100dvh-160px)]">
          <div>
            <Label htmlFor="name">Nom du chantier *</Label>
            <Input id="name" value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              placeholder="Ex: Residence Les Jardins" required
              data-testid="chantier-name-input" className="mt-1 h-14" />
          </div>
          <div>
            <Label htmlFor="address">Adresse *</Label>
            <Input id="address" value={formData.address}
              onChange={(e) => setFormData({...formData, address: e.target.value})}
              placeholder="Ex: 12 rue de la Paix, 75001 Paris" required
              data-testid="chantier-address-input" className="mt-1 h-14" />
          </div>
          <div>
            <Label htmlFor="client_name">Maître d'ouvrage *</Label>
            <Input id="client_name" value={formData.client_name}
              onChange={(e) => setFormData({...formData, client_name: e.target.value})}
              placeholder="Ex: SCI Immobiliere" required
              data-testid="chantier-client-input" className="mt-1 h-14" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label htmlFor="start_date">Date de début *</Label>
              <Input id="start_date" type="date" value={formData.start_date}
                onChange={(e) => setFormData({...formData, start_date: e.target.value})}
                required data-testid="chantier-start-date-input" className="mt-1 h-14" />
            </div>
            <div>
              <Label htmlFor="end_date">Date de fin <span className="text-xs text-gray-400">(optionnel)</span></Label>
              <Input id="end_date" type="date" value={formData.end_date}
                onChange={(e) => setFormData({...formData, end_date: e.target.value})}
                data-testid="chantier-end-date-input" className="mt-1 h-14" />
            </div>
          </div>
          <div>
            <Label htmlFor="status">Statut</Label>
            <Select value={formData.status}
              onValueChange={(value) => setFormData({...formData, status: value})}>
              <SelectTrigger className="mt-1 h-14" data-testid="chantier-status-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent position="popper" className="z-[100]">
                <SelectItem value="active" className="py-3">Actif</SelectItem>
                <SelectItem value="paused" className="py-3">En pause</SelectItem>
                <SelectItem value="completed" className="py-3">Terminé</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label htmlFor="description">Description <span className="text-xs text-gray-400">(optionnel)</span></Label>
            <Textarea id="description" value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              placeholder="Description du chantier..." rows={3}
              data-testid="chantier-description-input" className="mt-1" />
          </div>
          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="flex-1 h-14">
              Annuler
            </Button>
            <Button type="submit" disabled={submitting}
              className="flex-1 h-14 bg-[#0055FF] hover:bg-blue-700" data-testid="chantier-submit-btn">
              {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : (editingChantier ? 'Enregistrér' : 'Créer')}
            </Button>
          </div>
        </form>
      </SheetContent>
    </Sheet>
  );
}
